import { z } from "zod";
const schemaStorageGetParams = z.object({
    key: z.string().min(1),
    storeId: z.string().min(1).optional(),
});
const schemaStorageGetResults = z.object({
    value: z.string().optional(),
});
export const schemaStorageGet = {
    params: schemaStorageGetParams,
    result: schemaStorageGetResults,
};
//# sourceMappingURL=StorageGet.js.map